// extracted by mini-css-extract-plugin
module.exports = {"button":"StoreIndicator_button__Gj5nE","flag":"StoreIndicator_flag__a1DBI","lang":"StoreIndicator_lang__dxlZ_","indicatorContainer":"StoreIndicator_indicatorContainer__QTeUi"};